import styled from "styled-components";

export const CardWrapper = styled.div`
  width: 299px;
  height: 308px;
  border-radius: 8px;
  position: relative;
  background: ${({ background }) => (background ? background : "#fff")};
  box-shadow: 0px 4px 10px 0px #0000000a;

  & .card-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 10px 16px;
    font-weight: 500;
    font-size: 15px;
    color: #343c6a;
  }

  & .three-dots {
    cursor: pointer;
    color: #8490a5;
    font-size: 22px;
  }

  & .image-wrapper {
    width: 299px;
    height: 187px;
    /* border-radius: 10px 10px 0px 0px; */
    overflow: hidden;
    position: relative;

    & .ant-image {
      width: 100%;
      height: 100%;
      overflow: hidden;
      /* border-radius: 11px 11px 0px 0px; */
      background: #fff;
      & .ant-image-mask {
        border-radius: 11px 11px 0px 0px;
      }

      & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  & .card-title {
    width: 100%;
    margin-top: 12px;
    color: #343c6a;
    font-size: 18px;
    line-height: 20px;
    font-weight: 600;
    padding-left: 16px;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Qatordan soni */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & .card-body {
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    width: 100%;
    margin-top: 12px;
    padding-left: 16px;
    word-wrap: break-word;
    color: #8490a5;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Qatordan soni */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ThreeDotsContainer = styled.div`
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 1;
  width: 100px;
  height: 50px;
  font-size: 13px;
  font-weight: 500;
  background-color: #fff;
  color: #343c6a;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  cursor: pointer;
  box-shadow: 0px 0px 10px #cececf;
`;

export const UpdateIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: var(--sidebar-item-active);
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: red;
  }
`;
